import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
const WhatsAppWidget = () => {
  return <a href="https://wa.me/972505450460" target="_blank" rel="noopener noreferrer" className="fixed bottom-6 left-6 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg z-50 transition-all duration-300 hover:scale-110 flex items-center justify-center" aria-label="Contact us on WhatsApp" data-id="element-2361">
      <MessageCircleIcon className="h-6 w-6" data-id="element-2362" />
    </a>;
};
export default WhatsAppWidget;